import { calculateArea } from "@nova/calculate-geospatial"
import { convertArea } from "@nova/format"
import { LngLatCoordinatePair } from "features/map/event/types"
import polylabel from "../polylabel"
import { TextLayer } from "@deck.gl/layers"
import store from "integrations/redux/store"
import { PolygonGeometry } from "plugins/shared/layers/GeometryLinesLayer.class"
import { formatNumberWithCommas } from "@nova/util-strings"
import { AreaUnit, GeometryType } from "@nova/constants"
import { Coordinate } from "@nova/protobuf"
import { ibmPlexSans } from "configuration/fonts"
import { selectWorkspaceAreaUnit } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectRulersToDraw } from "features/entity-caching/rulers/selectors"
import { formatMap } from "./RulerMidpointText"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

export const RulerAreaTextLayer = (prefix: string, data: PolygonGeometry[] = []) => {
    const areas = data.filter(
        (e) => e.geometryType === GeometryType.Polygon && e.coordinates.length > 2
    )
    const state = store.getState()
    const workspaceAreaUnit = selectWorkspaceAreaUnit(state)
    const rulers = selectRulersToDraw(state)
    return new TextLayer({
        id: `${prefix}-ruler-polygon-area`,
        data: areas,
        getAlignmentBaseline: "center",
        fontWeight: 500,
        getSize: 10,
        background: true,
        getColor: [255, 255, 255],
        getBackgroundColor: [12, 12, 15, 243], // black-900
        backgroundBorderRadius: 6,
        backgroundPadding: [8, 4],
        fontFamily: ibmPlexSans.style.fontFamily,
        getTextAnchor: "middle",
        getPosition: (d: { coordinates: Coordinate[] }) =>
            polylabel([
                d.coordinates.map(({ longitude, latitude }) => [longitude, latitude]),
            ]) as unknown as LngLatCoordinatePair,
        getText: (d: { coordinates: Coordinate[]; deckGlIdx: number }) => {
            const area = calculateArea(d.coordinates)
            const ruler = rulers[d.deckGlIdx] as { areaUnit?: AreaUnit }
            const areaUnit = ruler.areaUnit || workspaceAreaUnit
            const converted = convertArea(area, AreaUnit.SquareMeters, areaUnit)
            return formatNumberWithCommas(converted) + " " + formatMap.area[areaUnit]
        },
        extensions: [...getGlobalTerrainData().extensions],
        parameters: { depthTest: false },
    })
}
